/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { MarketplaceWebhookAadIdentifier } from './MarketplaceWebhookAadIdentifier';
import type { MarketplaceWebhookTerm } from './MarketplaceWebhookTerm';
/**
 * Subscription object.
 */
export type MarketplaceWebhookSubscription = {
    /**
     * Gets or sets the identifier.
     */
    id?: string;
    /**
     * Gets or sets the name.
     */
    name?: string | null;
    /**
     * Gets or sets the PublisherID.
     */
    publisherId?: string | null;
    /**
     * Gets or sets the offer identifier.
     */
    offerId?: string | null;
    /**
     * Gets or sets the plan identifier.
     */
    planId?: string | null;
    /**
     * Gets or sets the quantity.
     */
    quantity?: number | null;
    /**
     * Gets or sets the beneficiary.
     */
    beneficiary?: MarketplaceWebhookAadIdentifier | null;
    /**
     * Gets or sets the purchaser.
     */
    purchaser?: MarketplaceWebhookAadIdentifier | null;
    /**
     * Gets or sets the allowed customer operations.
     */
    allowedCustomerOperations?: Array<string> | null;
    /**
     * Gets or sets the session mode.
     */
    sessionMode?: string | null;
    /**
     * Gets or sets the free trial status.
     */
    isFreeTrial?: boolean | null;
    /**
     * Gets or sets the test status.
     */
    isTest?: boolean | null;
    /**
     * Gets or sets the sandbox type.
     */
    sandboxType?: string | null;
    /**
     * Gets or sets the subscription status.
     */
    saasSubscriptionStatus?: MarketplaceWebhookSubscription.saasSubscriptionStatus;
    /**
     * Gets or sets the term details of the subscription.
     */
    term?: MarketplaceWebhookTerm | null;
    /**
     * Gets or sets the auto renew status of the subscription.
     */
    autoRenew?: boolean | null;
    /**
     * Gets or sets the created date of the subscription.
     */
    created?: string | null;
    /**
     * Gets or sets the last modified date of the subscription.
     */
    lastModified?: string | null;
};
export namespace MarketplaceWebhookSubscription {
    /**
     * Gets or sets the subscription status.
     */
    export enum saasSubscriptionStatus {
        PENDING_FULFILLMENT_START = 'PendingFulfillmentStart',
        SUBSCRIBED = 'Subscribed',
        UNSUBSCRIBED = 'Unsubscribed',
        PENDING_ACTIVATION = 'PendingActivation',
        SUSPENDED = 'Suspended',
    }
}

